export default function(){
	(function($) {


		// Open/close size chart
		var fromTop;
		function size_chart_modal_open(initial_slide){

			fromTop = $(window).scrollTop();
			$("html").css({
				top: -fromTop,
			});

			// Add body class
			$('html').addClass('has-modal has-modal--lightbox-gallery');
			init_single_product_lightbox_swiper(initial_slide)
		}

		function size_chart_modal_close(){
			$('html').removeClass('has-modal has-modal--lightbox-gallery');
			$(window).scrollTop(fromTop);
		}

		function size_chart_modal_init(){
			$('[close-size-chart]').click(function(e){
				if($('html').hasClass('has-modal--lightbox-gallery')){
					size_chart_modal_close();
				}
			});
		}
		size_chart_modal_init();

		$('body').on('click', '[open-lightbox-gallery]', function(e){
			e.preventDefault();
			setTimeout( () => {
				var init_slide = parseInt($(this).attr('lightbox-gallery-slide-to'))
				size_chart_modal_open( init_slide ? init_slide - 1 : 0 )
			} , 0 );
		});


		$(document).keyup(function(e) {
			if (e.key === "Escape") { // escape key maps to keycode `27`
				if($('html').hasClass('has-modal--lightbox-gallery')){
					size_chart_modal_close();
				}
			}
		});



		// Single product modal swiper
		var single_product_lightbox_swiper;
		function init_single_product_lightbox_swiper(initialSlide){

			if(single_product_lightbox_swiper){
				single_product_lightbox_swiper.destroy()
			}

			// Single product gallery Swiper
			single_product_lightbox_swiper = new Swiper('.single-product-lightbox-swiper', {
				initialSlide: initialSlide,
				speed: 300,
				loop: true,
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 2
				},
				pagination: {
					el: '.swiper-lightbox-pagination',
					type: 'fraction',
				},
				navigation: {
					nextEl: ".swiper-lightbox-arrow-next",
					prevEl: ".swiper-lightbox-arrow-prev",
				},
			});

			$("body").keydown(function(e) {
				if(e.keyCode == 38 || e.keyCode == 39) {
					single_product_lightbox_swiper.slideNext();
				}
				else if(e.keyCode == 37 || e.keyCode == 40) {
					single_product_lightbox_swiper.slidePrev();
				}
			});

		}


		// $(window).on('load resize', init_single_product_lightbox_swiper);

	})(jQuery);
}